import m from "mithril";
export default () => {
	let resizeObserver = null;
	let breakpoints;
	let OnWidthChange = null;

	function ManageResizeObjserver(element, breakpoints) {
		if ("ResizeObserver" in self) {
			if (!resizeObserver) {
				resizeObserver = new ResizeObserver(function (entries) {
					let defaultBreakpoints = {
						SM: 576,
						MD: 768,
						LG: 960,
					};

					entries.forEach(function (entry) {
						if (OnWidthChange) {
							OnWidthChange(entry.contentRect.width);
						}
						breakpoints = breakpoints || defaultBreakpoints;

						let bps = Object.keys(breakpoints).map((a) => {
							return {
								value: breakpoints[a],
								name: a,
							};
						});

						bps.sort((a, b) => a.value - b.value);

						bps.forEach(function (bp) {
							if (entry.contentRect.width <= bp.value) {
								entry.target.classList.add(bp.name);
							} else {
								entry.target.classList.remove(bp.name);
							}
						});
					});
				});
			}

			resizeObserver.observe(element);
		} else {
			entry.target.classList.add("XL");
		}
	}

	return {
		view: (v) => {
			OnWidthChange = v.attrs.OnWidthChange;

			return m(
				v.attrs.element || "Responsive-Component",
				{
					class: v.attrs.class,
					oncreate: (u) => {
						ManageResizeObjserver(u.dom, v.attrs.breakpoints);
					},
					style: v.attrs.style,
				},
				v.children
			);
		},
	};
};
